import types from "./billingEntityTypes";

export default (state, action) => {
	switch (action.type) {
		case types.SET_LOADING:
			return {
				...state,
				loading: !state.loading
			};
		case types.SET_BILLING_ENTITIES:
			return {
				...state,
				loading: false,
				billingEntities: action.payload
			};
		default:
			return state;
	}
};
